export enum IdentificationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
